<template>
  <v-layout wrap justify-center>
    <v-flex xs9>
      <v-card>
        <v-card-title>
          <v-layout row wrap>
            <v-flex xs9>
              <v-flex xs12>
                <h3>{{ machine.franchisee_machine_code + ' (' + (franchiseeLocation ? franchiseeLocation.display_name : $t('not_yet_allocated')) + ')' }}</h3>
              </v-flex>
              <v-flex xs12 v-if="franchiseeLocation && franchiseeLocation.address">
                <h5>{{ franchiseeLocation.address }}</h5>
              </v-flex>
            </v-flex>
            <v-flex pt-3 pr-2 xs3>
              <v-img :src="require('../assets/logo.png')" contain height="60px"></v-img>
            </v-flex>
          </v-layout>
        </v-card-title>
      </v-card>
      <v-tabs v-model="activeTab" color="primary" dark background-color="primary">
        <v-menu class="v-tabs__div" offset-y v-model="menu">
          <template v-slot:activator="{ on }">
            <a class="v-tab" v-on="on">
              {{ $t('report.reports' )}}
              <v-icon small>keyboard_arrow_down</v-icon>
            </a>
          </template>

          <v-list>
            <v-list-item
              v-for="(item, index) in franchiseeMachineReports"
              :key="index"
              @click="selectReport(item)"
            >
              <v-list-item-title>{{ item.period_name + ' (' + item.report_name + ')'}}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <!-- Hide report tab. Workaround to display report tab item -->
        <v-tab
          v-for="item in tabItems"
          :key="item.name"
          :href="`#${item.name}`"
          v-show="!item.report"
          class="primary"
        >{{ $t(item.text) }}</v-tab>

        <v-tabs-items v-model="activeTab" touchless>
          <v-tab-item
            v-for="item in tabItems"
            :key="item.name"
            :value="item.name"
          >
            <component
              :is="item.component"
              :report="item.report"
              :machine="machine"
              :franchisee-location="franchiseeLocation"
            ></component>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from 'moment'

import MonthlyReport from '@/components/machine/MonthlyReport'
import Transactions from '@/components/machine/Transactions'
import LocationSelection from '@/components/machine/LocationSelection'

export default {
  components: {
    MonthlyReport,
    Transactions,
    LocationSelection
  },

  data () {
    return {
      activeTab: 0,
      machine: null,
      menu: false,
      tabs: [
        {
          name: 'tab-transactions',
          text: 'title.transactions',
          component: 'Transactions',
          show: true
        },
        {
          name: 'tab-location-selection',
          text: 'title.location_selection',
          component: 'LocationSelection',
          show: false
        }
      ]
    }
  },

  computed: {
    franchiseeLocation () {
      let location = (
        this.machine.franchisee_location &&
        this.machine.franchisee_location.pivot &&
        this.machine.franchisee_location.pivot.location
      ) ? this.machine.franchisee_location.pivot.location : {}
      return this.machine.franchisee_location
        ? {
          display_name: this.machine.franchisee_location.display_name,
          ...location || {}
        }
        : null
    },

    franchiseeMachineReports () {
      return this.machine.franchisee_machine_reports.map(report => {
        return {
          period_name: moment(report.period, 'YYYYMM').format('MMM YYYY'),
          ...report
        }
      })
    },

    tabItems () {
      return this.franchiseeMachineReports.map(report => ({
        name: `tab-${report.id}`,
        component: 'MonthlyReport',
        show: true,
        report
      })).concat(this.tabs).filter((tab) => {
        return tab.show
      })
    }
  },

  created () {
    this.machine = this.getMachineData()
    if (this.franchiseeMachineReports.length > 0) {
      this.activeTab = `tab-${this.franchiseeMachineReports[0].id}`
    }
    let index = this.tabs.findIndex((tab) => tab.name === 'tab-location-selection')
    this.tabs[index].show = !!this.machine.machine_location_selection
  },

  methods: {
    getMachineData () {
      if (typeof this.$route.params.machineData !== 'undefined') {
        return this.$route.params.machineData
      }

      if (typeof this.$route.params.name !== 'undefined') {
        return this.$store.state.machinesData.find(machine => {
          return machine.franchisee_machine_code === this.$route.params.name
        })
      }

      return null
    },

    selectReport (report) {
      this.$nextTick(() => {
        this.activeTab = `tab-${report.id}`
      })
    }
  }
}
</script>
